import React, {useEffect, useState} from 'react';
import DataService from '../services/DataService';
import EuropeRecord from '../models/EuropeRecord';
import LatamRecord from '../models/LatamRecord';
import HerfindahlRecord from '../models/HerfindahlRecord';
import LatamConcentrationRecord from '../models/LatamConcentrationRecord';

export type GlobalDataContextType = {
  europeRecords: EuropeRecord[];
  latamRecords: LatamRecord[];
  latamHerfindahlRecords: HerfindahlRecord[];
  latamConcentrationRecords: LatamConcentrationRecord[];
  reaseguroConcentrationRecords: LatamConcentrationRecord[];
  reaseguroHerfindahlRecords: HerfindahlRecord[];
  reaseguroRecords: LatamRecord[];
  allDataLoaded: boolean;
}

const GlobalDataContext = React.createContext<GlobalDataContextType>({
  europeRecords: [],
  latamConcentrationRecords: [],
  latamHerfindahlRecords: [],
  latamRecords: [],
  reaseguroConcentrationRecords: [],
  reaseguroHerfindahlRecords: [],
  reaseguroRecords: [],
  allDataLoaded: false
});

// @ts-ignore
const GlobalDataContextProvider = ({ children }) => {
    const [europeRecords, setEuropeRecords] = useState<EuropeRecord[]>([]);
    const [latamRecords, setLatamRecords] = useState<LatamRecord[]>([]);
    const [latamHerfindahlRecords, setLatamHerfindahlRecords] = useState<HerfindahlRecord[]>([]);
    const [latamConcentrationRecords, setLatamConcentrationRecords] = useState<LatamConcentrationRecord[]>([]);
    const [reaseguroConcentrationRecords, setReaseguroConcentrationRecords] = useState<LatamConcentrationRecord[]>([]);
    const [reaseguroHerfindahlRecords, setReaseguroHerfindahlRecords] = useState<HerfindahlRecord[]>([]);
    const [reaseguroRecords, setReaseguroRecords] = useState<LatamRecord[]>([]);
    const [allDataLoaded, setAllDataLoaded] = useState<boolean>(false);

    const setData = (europeRecords: EuropeRecord[],
                     latamRecords: LatamRecord[],
                     latamHerfindahlRecords: HerfindahlRecord[],
                     latamConcentrationRecords: LatamConcentrationRecord[],
                     reaseguroConcentrationRecords: LatamConcentrationRecord[],
                     reaseguroHerfindahlRecords: HerfindahlRecord[],
                     reaseguroRecords: LatamRecord[]) => {
        setEuropeRecords(europeRecords);
        setLatamRecords(latamRecords);
        setLatamHerfindahlRecords(latamHerfindahlRecords);
        setLatamConcentrationRecords(latamConcentrationRecords);
        setReaseguroConcentrationRecords(reaseguroConcentrationRecords);
        setReaseguroHerfindahlRecords(reaseguroHerfindahlRecords);
        setReaseguroRecords(reaseguroRecords);

        if (
            europeRecords
              && latamRecords
              && latamHerfindahlRecords
              && latamConcentrationRecords
              && reaseguroConcentrationRecords
              && reaseguroHerfindahlRecords
              && reaseguroRecords) {
            setAllDataLoaded(true);
        }
    };

    useEffect(() => {
      const fetchData = async () => {
          const {
            europeRecords,
            latamRecords,
            latamHerfindahlRecords,
            latamConcentrationRecords,
            reaseguro
          }: any = await DataService.fetchInitialData();

          setData(
              europeRecords,
              latamRecords,
              latamHerfindahlRecords,
              latamConcentrationRecords,
              reaseguro.concentrationRecords,
              reaseguro.herfindahlRecords,
              reaseguro.records
          );
      };

      fetchData();
    }, [])

    return (
        <GlobalDataContext.Provider
            value={{
              europeRecords,
              latamRecords,
              latamHerfindahlRecords,
              latamConcentrationRecords,
              reaseguroConcentrationRecords,
              reaseguroHerfindahlRecords,
              reaseguroRecords,
              allDataLoaded
            }} >
          {children}
        </GlobalDataContext.Provider>
    );
};

export {
    GlobalDataContextProvider,
    GlobalDataContext,
}
